import React from "react";
import { CalendarClock, CalendarDays, Clock } from "lucide-react";

export default function AdminSchedules({ schedules, schools, filters, onFilter }) {
  const update = (k, v) => onFilter({ ...filters, [k]: v });
  const clear = () => onFilter({ school_id: "", donor_id: "", date: "", status: "" });

  return (
    <div className="space-y-4" data-testid="admin-visits-tab">
      <div className="bb-card p-5">
        <div className="bb-overline text-[var(--bb-muted)] mb-3 flex items-center gap-2"><CalendarClock size={14} /> Visit filters</div>
        <div className="grid md:grid-cols-5 gap-3 items-end">
          <div>
            <label className="bb-overline text-[var(--bb-muted)]">School</label>
            <select value={filters.school_id} onChange={(e) => update("school_id", e.target.value)} className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)] text-sm" data-testid="visit-filter-school">
              <option value="">All schools</option>
              {schools.map((s) => (<option key={s.school_id} value={s.school_id}>{s.name}</option>))}
            </select>
          </div>
          <div>
            <label className="bb-overline text-[var(--bb-muted)]">Date</label>
            <input type="date" value={filters.date} onChange={(e) => update("date", e.target.value)} className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)] text-sm" data-testid="visit-filter-date" />
          </div>
          <div>
            <label className="bb-overline text-[var(--bb-muted)]">Status</label>
            <select value={filters.status} onChange={(e) => update("status", e.target.value)} className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)] text-sm" data-testid="visit-filter-status">
              <option value="">All</option>
              <option value="scheduled">Scheduled</option>
              <option value="rescheduled">Rescheduled</option>
              <option value="completed">Completed</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>
          <div className="md:col-span-2">
            <label className="bb-overline text-[var(--bb-muted)]">Sponsor ID</label>
            <input
              type="text"
              value={filters.donor_id}
              onChange={(e) => update("donor_id", e.target.value)}
              placeholder="user_…"
              className="mt-2 w-full bg-transparent border-b border-[var(--bb-border)] py-2 outline-none focus:border-[var(--bb-terracotta)] text-sm"
              data-testid="visit-filter-donor"
            />
          </div>
        </div>
        <div className="mt-4 flex items-center gap-3 text-xs">
          <button onClick={clear} className="bb-link" data-testid="visit-filter-clear">Clear filters</button>
          <span className="text-[var(--bb-muted)]">{schedules.length} visit(s)</span>
        </div>
      </div>

      {schedules.length === 0 ? (
        <div className="bb-card p-10 text-center text-sm text-[var(--bb-muted)]">No visits found.</div>
      ) : (
        <div className="bb-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[var(--bb-sand)] bb-overline text-[var(--bb-muted)]">
              <tr>
                <th className="p-3 text-left">Date</th>
                <th className="p-3 text-left">Time</th>
                <th className="p-3 text-left">Sponsor</th>
                <th className="p-3 text-left">School</th>
                <th className="p-3 text-left">Notes</th>
                <th className="p-3 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {schedules.map((s) => (
                <tr key={s.schedule_id} className="border-t border-[var(--bb-border)]" data-testid={`admin-visit-${s.schedule_id}`}>
                  <td className="p-3"><div className="inline-flex items-center gap-1"><CalendarDays size={12} className="text-[var(--bb-muted)]" /> {s.scheduled_date}</div></td>
                  <td className="p-3"><div className="inline-flex items-center gap-1"><Clock size={12} className="text-[var(--bb-muted)]" /> {s.scheduled_time}</div></td>
                  <td className="p-3"><div className="font-medium">{s.donor_name || "—"}</div><div className="text-[10px] text-[var(--bb-muted)]">{s.donor_email}</div></td>
                  <td className="p-3">{s.school_name}</td>
                  <td className="p-3 text-xs text-[var(--bb-muted)] italic max-w-xs truncate">{s.notes || "—"}</td>
                  <td className="p-3"><span className={`bb-tag ${(s.status === "scheduled" || s.status === "rescheduled") ? "bb-tag-green" : ""}`}>{s.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
